let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2pDH6")).then(() => parcelRequire('3JhWg'));